import { render, staticRenderFns } from "./ModalCrud.vue?vue&type=template&id=13e536a7&scoped=true&"
import script from "./ModalCrud.vue?vue&type=script&lang=ts&"
export * from "./ModalCrud.vue?vue&type=script&lang=ts&"
import style0 from "./ModalCrud.vue?vue&type=style&index=0&id=13e536a7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e536a7",
  null
  
)

export default component.exports